import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-abteilung-setzen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsFunktionsbereichAbteilungSetzenEffects {

    FunktionsbereichAbteilungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_ABTEILUNG_SETZEN),
        mergeMap((x: ac.PostFunktionsbereichAbteilungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichAbteilungSetzen(x.incidentsFunktionsbereichAbteilungRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichAbteilungSetzenErfolgreichAction(result, x.incidentsFunktionsbereichAbteilungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichAbteilungSetzenFehlerAction(error, x.incidentsFunktionsbereichAbteilungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
